// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from '/usr/local/bin/src/models/useAddCasesDataSource';
import model_2 from '/usr/local/bin/src/models/useAddSupportingMaterialsDataSource';
import model_3 from '/usr/local/bin/src/models/useB2BBatchTransferDataSource';
import model_4 from '/usr/local/bin/src/models/useBatchMode';
import model_5 from '/usr/local/bin/src/models/useBatchTransferDataSource';
import model_6 from '/usr/local/bin/src/models/useGlobalPayoutBatchTransferDataSource';
import model_8 from '/usr/local/bin/src/models/usePayrollBatchTransferDataSource';
import model_9 from '/usr/local/bin/src/.umi-production/plugin-initialState/@@initialState';
import model_7 from '/usr/local/bin/src/models/useMerchantInfo';

export const models = {
model_1: { namespace: 'useAddCasesDataSource', model: model_1 },
model_2: { namespace: 'useAddSupportingMaterialsDataSource', model: model_2 },
model_3: { namespace: 'useB2BBatchTransferDataSource', model: model_3 },
model_4: { namespace: 'useBatchMode', model: model_4 },
model_5: { namespace: 'useBatchTransferDataSource', model: model_5 },
model_6: { namespace: 'useGlobalPayoutBatchTransferDataSource', model: model_6 },
model_8: { namespace: 'usePayrollBatchTransferDataSource', model: model_8 },
model_9: { namespace: '@@initialState', model: model_9 },
model_7: { namespace: 'useMerchantInfo', model: model_7 },
} as const
